import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBookmeterComponent } from './simple-icons-bookmeter.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBookmeterComponent ],
    exports:      [ SimpleIconsBookmeterComponent ],
    bootstrap:    []
})
export class SimpleIconsBookmeterModule {}
